import React, { useState,useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Tooltip } from "react-tooltip";
import { toast } from 'react-toastify';
import CheckCurrentPlan from "../../../../components/CheckCurrentPlan";
import { submitChatTemplate } from "../../../../utils/chatApi";

//Import Widgets
import CommonTemplate from "../../../../components/Apps/TelegramChat/Template/CommonTemplate";

//Import Tabs
import ConnectTab from "../../../../components/Apps/TelegramChat/ConnectTab";
import ContentTab from "../../../../components/Apps/TelegramChat/ContentTab";
import SettingTab from "../../../../components/Apps/TelegramChat/SettingTab";
import AppearanceTab from "../../../../components/Apps/TelegramChat/AppearanceTab";

export default function CreateTelegramChat() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [showTemplateSelection, setShowTemplateSelection] = useState(true);
    const [activeSection, setActiveSection] = useState("Connect");
    const [activeTemplateSection, setActiveTemplateSection] = useState("General_Temp");
    const [selectedLayout, setSelectedLayout] = useState("general_layout");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("general.png");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Telegram Chat");
    const [newWidgetName, setNewWidgetName] = useState("");

    const [chatTabData, setChatTabData] = useState({
        is_website_frontend: "", 
        telegram_username: "",  
        bubble_icon: "",  
        bubble_text: "",  
        chat_window_picture: "",  
        chat_window_name: "",  
        chat_window_caption: "Online",  
        welcome_message: "",   
        start_chat_button_text: "",  
        is_show_start_chat_button: 1,  
        position_alignment_type: "right-side",  
        position_vertical_offset: "",  
        position_horizonantal_offset: "",  
        chat_display_pages_type: "All_Pages",  
        chat_display_devices: ["Desktop", "Mobile Devices"],
        chat_display_visitors_type: "All_Visitors",  
        display_chat_days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],  
        chat_display_is_schedule: 1,  
        chat_display_start_time: "12:00 AM",  
        chat_display_end_time: "1:00 AM",  
        chat_display_time_zone: "",  
        chat_triggers_is_on_page_load: 1,  
        chat_triggers_time_on_page: "",  
        chat_triggers_time_on_site: "",  
        chat_triggers_scroll_position: "",  
        chat_triggers_is_exit_intent: 1,  
        chat_triggers_remembers_visitors: "1 Day",  
        is_show_bubble_notification_badge: 1,  
        font_type: "",  
        chat_window_name_color: "",  
        chat_window_caption_color: "", 
        bubble_background_color: "",  
        bubble_icon_color: "",  
        notification_badge_color: "",  
        header_background_color: "",  
        header_text_color: "",  
        online_status_color: "",  
        chat_wallpaper_color: "",  
        message_background_color: "",  
        message_field_color: "",  
        button_color: "",  
        enable_animation: "",  
        animation_interval: "",  
        custom_css:  "",  
        custom_js: "",  
    });

    // Set Template Setting And Texts when activeTemplateSection changes
    useEffect(() => {
        let chat_window_picture = "";
        let chat_window_name = "";  
        let chat_window_name_color = "";  
        let chat_window_caption_color = "";  
        let bubble_background_color = "";
        let bubble_icon_color = "";
        let notification_badge_color = "";
        let header_background_color = "";
        let header_text_color = "";
        let online_status_color = "";
        let chat_wallpaper_color = "";
        let message_background_color = "";
        let message_field_color = "";
        let button_color = "";
        let bubble_icon = "";
        let bubble_text = "";
        let welcome_message = "";
        let start_chat_button_text = "";  
    
        switch (activeTemplateSection) {
            case "General_Temp":
                chat_window_name = "John Doe";  
                chat_window_picture = `${process.env.PUBLIC_URL}/telegram-chat/templates/general-pro.png`;
                chat_window_name_color = "#fff";
                chat_window_caption_color = "#fff";
                bubble_background_color = "#0188cc";
                bubble_icon_color = "#fff";
                notification_badge_color = "#f00";
                header_background_color = "#0188ca";
                header_text_color = "#fff";
                online_status_color = "#4ad504";
                chat_wallpaper_color = "#fff";
                message_background_color = "#efefef";
                message_field_color = "#fff";
                button_color = "#0385cd";
                bubble_icon = "";
                bubble_text = "";
                welcome_message = "Hi there 👋 How can I help you?";
                start_chat_button_text = "Start Chat";
                break;
            case "Support_Temp":
                chat_window_name = "Nancy";  
                chat_window_picture = `${process.env.PUBLIC_URL}/telegram-chat/templates/support-pro.png`;
                chat_window_name_color = "#000";
                chat_window_caption_color = "#000";
                bubble_background_color = "#000";
                bubble_icon_color = "#fff";
                notification_badge_color = "#f00";
                header_background_color = "#fff";
                header_text_color = "#fff";
                online_status_color = "#4ad504";
                chat_wallpaper_color = "#fff";
                message_background_color = "#efefef";
                message_field_color = "#fff";
                button_color = "#07c763";
                bubble_icon = "";
                bubble_text = "Need Help?";
                welcome_message = "Hey there 👋 I'm here to help, so let me know what's up and I'll be happy to find a solution 🤓";
                start_chat_button_text = "Start Chat";
                break;
            case "Sale_Temp":
                chat_window_name = "John";  
                chat_window_picture = `${process.env.PUBLIC_URL}/telegram-chat/templates/sale-pro.png`;
                chat_window_name_color = "#fff";
                chat_window_caption_color = "#fff";
                bubble_background_color = "#172228";
                bubble_icon_color = "#fff";
                notification_badge_color = "#f00";
                header_background_color = "#000";
                header_text_color = "#172228";
                online_status_color = "#4ad504";
                chat_wallpaper_color = "#fff";
                message_background_color = "#efefef";
                message_field_color = "#fff";
                button_color = "#df050a";
                bubble_icon = "";
                bubble_text = "";
                welcome_message = "Looking for the best offer? 🤑 I'm happy to tell you about our fantastic sale - up to 50% discount! Let me know if you've got questions.";
                start_chat_button_text = " Chat With John";
                break;
            case "Booking_Temp":
                chat_window_name = "Lisa";  
                chat_window_picture = `${process.env.PUBLIC_URL}/telegram-chat/templates/booking-pro.png`;
                chat_window_name_color = "#fff";
                chat_window_caption_color = "#fff";
                bubble_background_color = "#023586";
                bubble_icon_color = "#fff";
                notification_badge_color = "#f00";
                header_background_color = "#003585";
                header_text_color = "#000";
                online_status_color = "#4ad504";
                chat_wallpaper_color = "#fff";
                message_background_color = "#efefef";
                message_field_color = "#fff";
                button_color = "#0087ca";
                bubble_icon = "";
                bubble_text = "Book a Room";
                welcome_message = "Looking for a place to stay in NYC? Let me know what you need and I'll find you the best option.";
                start_chat_button_text = "Start Chat";
                break;
            case "Feedback_Temp":
                chat_window_name = "David";  
                chat_window_picture = `${process.env.PUBLIC_URL}/telegram-chat/templates/feedback-pro.png`;
                chat_window_name_color = "#000";
                chat_window_caption_color = "#000";
                bubble_background_color = "#fe9a00";
                bubble_icon_color = "#fff";
                notification_badge_color = "#f00";
                header_background_color = "#fff8e8";
                header_text_color = "#fff";
                online_status_color = "#4ad504";
                chat_wallpaper_color = "#fff";
                message_background_color = "#efefef";
                message_field_color = "#fff";
                button_color = "#fe9a00";
                bubble_icon = "";
                bubble_text = "Feedback";
                welcome_message = "Hi there 👋 Sorry to interrupt. Quick question - how do you like this new product so far?";
                start_chat_button_text = "Share Feedback";
                break;
            case "Onboarding_Temp":
                chat_window_name = "John Doe";  
                chat_window_picture = `${process.env.PUBLIC_URL}/telegram-chat/templates/general-pro.png`;
                chat_window_name_color = "#000";
                chat_window_caption_color = "#000";
                bubble_background_color = "#a755ff";
                bubble_icon_color = "#fff";
                notification_badge_color = "#f00";
                header_background_color = "#fff";
                header_text_color = "#fff";
                online_status_color = "#4ad504";
                chat_wallpaper_color = "#fff";
                message_background_color = "#efefef";
                message_field_color = "#fff";
                button_color = "#a755ff";
                bubble_icon = "";
                bubble_text = "";
                welcome_message = "Did you know that this widget can help you provide support, consult customers, do sales, collect feedback and build customer relationships? Drop me a line and I'll tell you how 🤩";
                start_chat_button_text = "Start Chat";
                break;
            default:
                chat_window_name = "";  
                chat_window_picture = "";
                chat_window_name_color = "";
                chat_window_caption_color = "";
                bubble_background_color = "";
                header_background_color = "";
                bubble_icon_color = "";
                notification_badge_color = "";
                header_text_color = "";
                online_status_color = "";
                chat_wallpaper_color = "";
                message_background_color = "#efefef";
                message_field_color = "";
                button_color = "";
                bubble_icon = "";
                bubble_text = "";
                welcome_message = "";
                start_chat_button_text = "";
        }
    
        // Update setChatTabData state with the data
        setChatTabData((prevData) => ({
            ...prevData,
            chat_window_name: chat_window_name,
            chat_window_picture: chat_window_picture,
            chat_window_name_color: chat_window_name_color,
            chat_window_caption_color: chat_window_caption_color,
            bubble_background_color: bubble_background_color,
            bubble_icon_color: bubble_icon_color,
            notification_badge_color: notification_badge_color,
            header_background_color: header_background_color,
            header_text_color: header_text_color,
            online_status_color: online_status_color,
            chat_wallpaper_color: chat_wallpaper_color,
            message_background_color: message_background_color,
            message_field_color: message_field_color,
            button_color: button_color,
            bubble_icon: bubble_icon,
            bubble_text: bubble_text,
            welcome_message: welcome_message,
            start_chat_button_text: start_chat_button_text,
        }));
    
    }, [activeTemplateSection]);

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateChatTabData = (key, value) => {
        setChatTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleContinueTemplate = () => {
        setShowTemplateSelection(false);
        setIsSubmitting(false);
        //Get the currently checked radio button
        const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
        if (selectedRadio) {
            const layoutTypeValue = selectedRadio.dataset.layout_type;
            setSelectedLayout(layoutTypeValue);
        } else {
            alert('Please select a template');
        }
    }; 

    const menuItems = [
        { key: "Connect", icon: "connect.png", label: "Connect" },
        { key: "Content", icon: "content.png", label: "Content" },
        { key: "Settings", icon: "setting.png", label: "Settings" },
        { key: "Appearance", icon: "apperance.png", label: "Appearance" },
    ];

    // Handle Source Tab input change
    const handleActiveTemplateInputChange = (event) => {
        setActiveTemplateSection(event.target.value);
        //Get the currently checked radio button
        const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
        if (selectedRadio) {
            const layoutTypeValue = selectedRadio.dataset.layout_type;
            const template_image = selectedRadio.dataset.template_image;
            setSelectedLayout(layoutTypeValue);
            setSelectedTemplateImage(template_image);
        } else {
            alert('Please select a template');
        }
    };

    //Submit Form data
    const submitForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            const formData = new FormData();

            // Append text fields
            formData.append("name", widgetName);
            formData.append("template_name", activeTemplateSection);
            formData.append("template_image", selectedTemplateImage);
            formData.append("layout_name", selectedLayout);
            formData.append("layout_type", selectedLayout);
            formData.append("app_type", "Telegram_Chat");
    
            // Append settings as JSON string
            formData.append(
                "settings",
                JSON.stringify(
                    Object.entries(chatTabData).map(([key, value]) => ({
                        setting_key: key,
                        setting_value: value,
                    }))
                )
            );

            // Check if chat_window_picture is a File and append it
            if (chatTabData.chat_window_picture) {
                // If it's a File object (newly uploaded), append it directly
                if (chatTabData.chat_window_picture instanceof File) {
                    formData.append("chat_window_picture", chatTabData.chat_window_picture);
                } 
                // If it's a string (from predefined template), just send the image file name
                else if (typeof chatTabData.chat_window_picture === 'string') {
                    const imageName = chatTabData.chat_window_picture.split('/').pop();
                    formData.append("chat_window_picture", imageName);
                }
            }
         
            //Api Call
            let api_response = await submitChatTemplate(formData);

            //Check Responce
            if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/telegram-chat');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
          <div className="create-goole-reviews-all">
            <CheckCurrentPlan from_page={true} app_name="Telegram Chat" app_type="Telegram_Chat" app_slug="telegram-chat"/>
                {showTemplateSelection ? (
                    <div className="create-goole-reviews-side">
                        <span>Select a template to start with</span>
                        <div className="card h-100">
                            <div className="label-box-flex">
                                <label className="card-radio-btn">
                                    <input type="radio" name="app_template_type" className="card-input-element d-none" value="General_Temp" data-layout_type="general_layout" data-template_image="general.png" checked={activeTemplateSection === "General_Temp"} onChange={handleActiveTemplateInputChange} />
                                    <div className="card card-body">
                                        <div className="content_head">
                                            <img src={`${process.env.PUBLIC_URL}/telegram-chat/templates/general.png`} alt="general" />
                                        </div>
                                        <div className="content_sub">General</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="app_template_type" className="card-input-element d-none" value="Support_Temp" data-layout_type="support_layout" data-template_image="support.png" checked={activeTemplateSection === "Support_Temp"} onChange={handleActiveTemplateInputChange} />
                                    <div className='card card-body'>
                                        <div className="content_head">
                                            <img src={`${process.env.PUBLIC_URL}/telegram-chat/templates/support.png`} alt="support" />
                                        </div>
                                        <div className="content_sub">Support</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="app_template_type" className="card-input-element d-none" value="Sale_Temp" data-layout_type="sale_layout" data-template_image="sale.png" checked={activeTemplateSection === "Sale_Temp"} onChange={handleActiveTemplateInputChange} />
                                    <div className='card card-body'>
                                        <div className="content_head">
                                            <img src={`${process.env.PUBLIC_URL}/telegram-chat/templates/sale.png`} alt="sale" />
                                        </div>
                                        <div className="content_sub">Sale</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="app_template_type" className="card-input-element d-none" value="Booking_Temp" data-layout_type="booking_layout" data-template_image="booking.png" checked={activeTemplateSection === "Booking_Temp"} onChange={handleActiveTemplateInputChange} />
                                    <div className='card card-body'>
                                        <div className="content_head">
                                            <img src={`${process.env.PUBLIC_URL}/telegram-chat/templates/booking.png`} alt="booking" />
                                        </div>
                                        <div className="content_sub">Booking</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="app_template_type" className="card-input-element d-none" value="Feedback_Temp" data-layout_type="feedback_layout" data-template_image="feedback.png" checked={activeTemplateSection === "Feedback_Temp"} onChange={handleActiveTemplateInputChange} />
                                    <div className='card card-body'>
                                        <div className="content_head">
                                            <img src={`${process.env.PUBLIC_URL}/telegram-chat/templates/feedback.png`} alt="feedback" />
                                        </div>
                                        <div className="content_sub">Feedback</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="app_template_type" className="card-input-element d-none" value="Onboarding_Temp" data-layout_type="onboarding_layout"  data-template_image="onboarding.png" checked={activeTemplateSection === "Onboarding_Temp"} onChange={handleActiveTemplateInputChange} />
                                    <div className='card card-body'>
                                        <div className="content_head">
                                            <img src={`${process.env.PUBLIC_URL}/telegram-chat/templates/onboarding.png`} alt="onboarding" />
                                        </div>
                                        <div className="content_sub">Onboarding</div>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div className="continue-template">
                            <button onClick={handleContinueTemplate}>Continue with this template</button>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="overlay-side-baar">
                            <div className="side-baar-inner-one">
                                <ul>
                                    {menuItems.map((item) => (
                                        <li key={item.key}>
                                            <button
                                                className={activeSection === item.key ? "active" : ""}
                                                onClick={() => setActiveSection(item.key)}
                                            >
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/telegram-chat/icons//${item.icon}`}
                                                    alt={`${item.key} icon`}
                                                />
                                                <span>{item.label}</span>
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="side-baar-inner-tow">
                                {/* Conditional Rendering for Sections */}
                                {activeSection === "Connect" && (
                                  <ConnectTab updateChatTabData={updateChatTabData} chatTabData={chatTabData}/>
                                )}
                                
                                {activeSection === "Content" && (
                                  <ContentTab updateChatTabData={updateChatTabData} chatTabData={chatTabData}/>
                                )}

                                {activeSection === "Settings" && (
                                  <SettingTab updateChatTabData={updateChatTabData} chatTabData={chatTabData}/>
                                )}

                                {activeSection === "Appearance" && (
                                  <AppearanceTab updateChatTabData={updateChatTabData} chatTabData={chatTabData}/>
                                )}
                            </div>
                        </div>
                    </>
                )}
                <div className="create-goole-reviews-right">
                    <div className="content-wrapper">
                        <div className="source-header-row">
                            <h2><Link to="/customer/apps/telegram-chat"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link></h2>
                            <div className="untitled-widget-name whtsapp-icon">
                                <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/images/app-icon/telegram-chat.svg`} alt="telegram-chat"/>{ widgetName }</button>
                                <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                            </div>
                            <div className='submit-google-review'>
                              <button type="button" onClick={submitForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                              <Link to="/customer/apps/telegram-chat/pricing/single" className="view-plan">View Plans</Link>
                              <Link to="/customer/apps/telegram-chat" className="close-button">Close</Link></div>
                        </div>
                        <div className="source-title-row">Telegram Chat <img src={`${process.env.PUBLIC_URL}/images/icon-24.png`} alt="icon-24" /> <strong>Connect</strong></div>

                        {/*Call Common template*/}
                        <CommonTemplate selectedTemplate={activeTemplateSection} selectedLayout={selectedLayout} chatTabData={chatTabData} /> 
                    </div>
                </div>
            </div>

            {/* Rename Popup */}
            {renameWidgetNameModel && (
                <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                    <div className="bg-white p-3 rounded-lg shadow-lg">
                        <h3 className="text-lg font-semibold">Rename Widget</h3>
                        <label>Widget Name</label>
                        <input
                            type="text"
                            className="border p-2 w-full mt-2"
                            value={newWidgetName}
                            onChange={(e) => setNewWidgetName(e.target.value)}
                        />
                        <div className="mt-3 flex justify-end">
                            <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                                Cancel
                            </button>
                            <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
      );
}
